import _ from "lodash";

export const getLeftPlayer = (
  status,
  isAskerPlayer,
  isAnswererPlayer,
  ready_to_vote,
  askerPlayer,
  answererPlayer
) => {
  if (status === "Question" && isAskerPlayer && ready_to_vote) {
    return answererPlayer;
  } else if (status === "Question" && !isAskerPlayer) {
    return answererPlayer;
  } else if (status === "Result" || status === "FlusterIntro") {
    return answererPlayer;
  } else if (status === "FlusterQuestion" && !isAskerPlayer) {
    return answererPlayer;
  } else if (status === "AroundTheHornQuestion" && isAnswererPlayer) {
    return answererPlayer;
  } else if (status === "AroundTheHornResult") {
    return answererPlayer;
  } else {
    return askerPlayer;
  }
};
export const getRightPlayer = (
  status,
  askerPlayer,
  isAskerPlayer,
  ready_to_vote,
  answererPlayer,
  currentPlayerVote
) => {
  if (status === "Answerer") {
    return answererPlayer;
  }
  if (status === "Question" && isAskerPlayer && !ready_to_vote) {
    return answererPlayer;
  }
  if (
    status === "FlusterQuestion" &&
    !isAskerPlayer &&
    _.isEmpty(currentPlayerVote)
  ) {
    return askerPlayer;
  }
  if (status === "AroundTheHornResult") {
    return askerPlayer;
  } else {
    return {};
  }
};

export const getWords = (
  status,
  isAskerPlayer,
  ready_to_vote,
  currentPlayerVote,
  isAnswererPlayer
) => {
  if (status === "Asker" && isAskerPlayer) {
    return "You are the asker. Choose your answerer.";
  } else if (status === "Asker" && !isAskerPlayer) {
    return "Is picking somebody to ask a question.";
  } else if (status === "Answerer") {
    return "Asks";
  } else if (status === "Question" && isAskerPlayer && !ready_to_vote) {
    return "Asks";
  } else if (
    status === "Question" &&
    isAskerPlayer &&
    ready_to_vote &&
    _.isEmpty(currentPlayerVote)
  ) {
    return "is answering the card";
  } else if (status === "Question" && isAnswererPlayer) {
    return "Answer the question";
  } else if (
    status === "Question" &&
    !isAskerPlayer &&
    !isAnswererPlayer &&
    _.isEmpty(currentPlayerVote)
  ) {
    return "is answering the card.";
  } else if (
    status === "Question" ||
    (status === "FlusterQuestion" && !_.isEmpty(currentPlayerVote))
  ) {
    return "You have voted!";
  } else if (status === "FlusterIntro") {
    return "FLUSTER CARD PLAYED!!!";
  } else if (status === "FlusterQuestion" && isAskerPlayer) {
    return "Answer the question";
  } else if (status === "FlusterQuestion" && !isAskerPlayer) {
    return "Now";
  } else if (
    status === "AroundTheHornIntro" ||
    (status === "AroundTheHornQuestion" && !isAnswererPlayer)
  ) {
    return "AROUND THE HORN CARD PLAYED!!!";
  } else if (status === "AroundTheHornQuestion" && isAnswererPlayer) {
    return "You played Around The Horn! Pick the best answerer";
  } else if (status === "AroundTheHornResult") {
    return "choose";
  } else if (status === "Result" || status === "FlusterResult") {
    return "Round over!";
  } else if (status === "FlusterQuestion" && !isAskerPlayer) {
    return "Now";
  } else {
    return {};
  }
};
export const getDescription = (
  status,
  askerPlayer,
  answererPlayer,
  isAnswererPlayer
) => {
  if (status === "Question" && isAnswererPlayer) {
    return "or play a Fluster card or Around the Horn card";
  }
  if (status === "FlusterIntro") {
    return "Now the Asker becomes the Answerer";
  }
  if (
    status === "AroundTheHornIntro" ||
    (status === "AroundTheHornQuestion" && !isAnswererPlayer)
  ) {
    return "Everyone must answer the question now!";
  }
  if (status === "FlusterResult") {
    return `${askerPlayer?.display_name} recieved an average of`;
  }
  if (status === "Result") {
    return `${answererPlayer?.display_name} recieved an average of`;
  } else {
    return "";
  }
};

export const showBottomText = (status, isAskerPlayer) => {
  if (status === "FlusterQuestion" && !isAskerPlayer) {
    return true;
  }
  if (status === "AroundTheHornResult") {
    return true;
  } else {
    return false;
  }
};

export const rightBottomText = (status, isAskerPlayer) => {
  if (status === "FlusterQuestion" && !isAskerPlayer) {
    return "Must answer the Question";
  } else {
    return "";
  }
};
export const leftBottomText = (status, isAskerPlayer) => {
  if (status === "FlusterQuestion" && !isAskerPlayer) {
    return "Has played a";
  }
  if (status === "AroundTheHornResult") {
    return "Has played a";
  } else {
    return "";
  }
};

export const leftBoldBottomText = (status, isAskerPlayer) => {
  if (status === "FlusterQuestion" && !isAskerPlayer) {
    return "Fluster Card";
  }
  if (status === "AroundTheHornResult") {
    return "Around the Horn";
  } else {
    return "";
  }
};
export const rightBoldBottomText = (status, isAskerPlayer) => {
  if (status === "AroundTheHornResult") {
    return "Up Next!";
  } else {
    return "";
  }
};
